import { render, staticRenderFns } from "./staff-detail.vue?vue&type=template&id=2f07ad94&scoped=true&"
import script from "./staff-detail.vue?vue&type=script&lang=js&"
export * from "./staff-detail.vue?vue&type=script&lang=js&"
import style0 from "./staff-detail.vue?vue&type=style&index=0&id=2f07ad94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f07ad94",
  null
  
)

export default component.exports